var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-search" }, [
    _c(
      "div",
      { staticClass: "filter-search__wrapper" },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query"
            }
          ],
          staticClass: "input-custom",
          attrs: {
            id: _vm.searchInputId,
            name: "query",
            "aria-label":
              "Wyszukiwanie w filtrze " + _vm.name + " – pole edycji"
          },
          domProps: { value: _vm.query },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.query = $event.target.value
              },
              _vm.onInput
            ]
          }
        }),
        _vm._v(" "),
        _c("SearchIcon", {
          staticClass: "filter-search__icon",
          attrs: { width: "24", height: "24" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.displayMessage && _vm.query && !_vm.queryResults.length
      ? _c("p", { staticClass: "filter-search__noresult" }, [
          _vm._v("\n        " + _vm._s(_vm.i18n("No results")) + "\n    ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }